import { render } from "./AddTaskType.vue?vue&type=template&id=65de2077"
import script from "./AddTaskType.vue?vue&type=script&lang=js"
export * from "./AddTaskType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__